module.exports = __webpack_public_path__ + "img/flavor_lychee.e9948e27.png";